module.exports = __webpack_public_path__ + "img/val-5-min.968ea568.jpg";